import React from 'react'

const Footer = () => {
    return (
        <footer>Copyright © 2023 PopCorn Jam Group</footer>
    )
}

export default Footer